const messagingTranslations = {
  conversation: {
    type: {
      label: "Kategorie",
      values: {
        submitCaseInfo: "Informationen/Neuigkeiten zum Fall",
        submitDocuments: "Nur Unterlagen einreichen",
        other: "Allgemeine Nachricht",
        questionNextSteps: "Rückfrage zum weiteren Vorgehen",
        legalQuestion: "Rechtliche Frage",
        technicalQuestion: "Frage zur Servicewelt",
      },
    },
  },
};
export default messagingTranslations;
